export const DataCatalogueMessages = {
  TITLE: 'Data Sphere',
  SUBTITLE:
    'Manage all your essential data—documents, claims, and more—in one streamlined, secure hub.',
  TABS: [
    'Overview',
    'Medical',
    'Rx',
    'Census',
    'Aggregate Reports',
    // 'Invoices',
    // 'Check Register',
    'Drugs Savings Program',
  ],
  DATA_FILES: 'Data Files',
  PRIMARY_TAB: {
    SERVER_DETAILS: {
      TITLE: 'Server Details',
      SUBTITLE: 'SFTP or Sharefile Link and Frequency of Update',
    },
    DATA_SUMMARY: {
      TITLE: 'Data Summary',
      SUBTITLE: 'Summary of the data shared',
    },
  },
  UPLOAD_INFO:
    'Bulk uploads may take some time to complete depending on the file size and number of files.',

  AGGREGATE_REPORT_TAB: {
    YEAR: 'Select Plan Start Date and Plan End Date',
    ADD_COLUMNS: 'Add Columns: ',
    SPECIFIC_STOPLOSS: 'specific_stoploss',
    AGGREGATE_STOPLOSS: 'aggregate_stoploss',
    AGGREGATE_REPORT: 'aggregate_report',
    DOWNLOAD_CSV: 'Download Sample CSV',
    UPLOAD_REPORT: 'Upload Aggregate Report',
    CONFIRM_UPDATE: 'Confirm Update Aggregate Report',
    CONFIRMATION_MSG: (startDate: string, endDate: string) => {
      return `Aggregate Report for <b>${startDate}</b> to <b>${endDate}</b> already exists! Are you sure you want to update Aggregate Report?`;
    },
    TOP_CARDS: {
      SPECIFIC_STOPLOSS: {
        TITLE: 'Specific Stop Loss',
        SUBTITLE: 'Add specific stop loss data',
        BTN_LABEL: '+ Add New Row',
      },
      AGGREGATE_STOPLOSS: {
        TITLE: 'Aggreagate Stop Loss',
        SUBTITLE: 'Add aggregate stop loss data',
        BTN_LABEL: '+ Add New Row',
      },
    },
  },

  INVOICES_TAB: {
    TITLE: 'Upload Invoice',
  },
  CHECK_REGISTER_TAB: {
    TITLE: 'Upload Check Register',
  },
  SAVINGS_PROGRAM_LABELS: {
    YEAR: 'Select the Start Date and End Date for Drugs Savings Program',
    SAVINGS_PROGRAM: 'Savings Program',
    BENCHMARK_COLUMN: 'Benchmark Column',
  },
  OVERVIEW_TAB: {
    GOI: {
      TITLE: 'General Organization Information',
      KEY: 'goi',
      ROW_DATA: {
        organization_name: 'Organization Name',
        head_office_city:
          'Primary Place of Business (Head Office) - City, State',
        head_office_address:
          'Primary Place of Business (Head Office) - Address',
        satellite_location:
          'Satellite Locations or Remote Work Locations (City and State or Zip Code):',
        industry_type: 'SIC Code/Industry Type',
        primary_contact:
          'Primary Contact - Name, Designation, Email & Phone number',
        number_of_employees: 'Number of enrolled employees',
      },
    },
    EHPO: {
      TITLE: 'Employee Health Plan Overview',
      KEY: 'ehpo',
      ROW_DATA: {
        health_benefits_offered: 'Type of Health Benefits Offered',
        number_of_health_plans: 'Number of Health Plans Offered',
        renewal_date: 'Renewal Date',
        plan_funding_type:
          'Plan Funding Type (e.g., Fully Insured, Self-Insured)',
        types_of_plans: 'Types of Plans Offered (e.g., PPO, HMO, HDHP, etc.)',
        eligibility_requirements: 'Eligibility Requirements (if any)',
      },
    },
    KVP: {
      TITLE: 'Key Vendors and Partners',
      KEY: 'kvp',
      ROW_DATA: {
        premium_contribution:
          'Premium contribution by plan (employer/employee)',
        broker_consultant: 'Broker/Consultant Name',
        // broker_consultant_contact:
        //   'Broker/Consultant Contact Detail (Email, Phone number)',
        // broker_consultant_poc:
        //   'Broker/Consultant Point of Contact Details (Name, Email & phone number)',
        tpa_claims_administrator: 'TPA/Claims Administrator Name',
        // tpa_admin_contact:
        //   'TPA/Claims Administrator Contact Details (Email, Phone number)',
        // tpa_admin_poc:
        //   'TPA/Claims Administrator Point of Contact Details (Name, Email & phone number)',
        pharmacy_benefit_manager: 'Pharmacy Benefit Manager (PBM) Name',
        // pbm_contact:
        //   'Pharmacy Benefit Manager (PBM) Contact Details (Email & phone number)',
        network_carrier: 'Network Carrier Name',
        // network_carrier_contact:
        //   'Network Carrier Contact Details (Email, Phone number)',
        // network_carrier_poc:
        //   'Network Carrier Point of Contact Details (Name, Email & phone number)',
        stop_loss_insurer: 'Stop-Loss Insurance Carrier Name',
        // stop_loss_insurer_contact:
        //   'Stop-Loss Insurance Carrier Contact Details (Email, Phone number)',
        // stop_loss_insurer_poc:
        //   'Stop-Loss Insurance Carrier Point of Contact Details (Name, Email & phone number)',
      },
    },
    PS: {
      TITLE: 'Point Solutions (One or Multiple)',
      KEY: 'PS',
      ROW_DATA: {
        name: 'Name',
        type: 'Type of Point Solution',
        contact_email: 'Contact Details (Email, Phone number)',
        point_of_contact:
          'Point of Contact Details (Name, Email & phone number)',
        contracted_through: 'Contracted directly or through Payer',
      },
    },
  },
};
